import React from 'react';

interface ProUpgradeProps {
  onClose: () => void;
  feature?: string;
}

// All Pro features are now available to everyone - this component just closes
const ProUpgrade: React.FC<ProUpgradeProps> = ({ onClose }) => {
  // Just close the modal since all features are now available
  React.useEffect(() => {
    onClose();
  }, [onClose]);

  return null;
};

export default ProUpgrade;
